module.exports = __webpack_public_path__ + "static/media/Tapu Lele_gaussian2.bab053e3.png";